import * as React from 'react';
import { FormField } from './FormField';
import { Flex } from '../compositeComponents/FlexHelpers';
import { OnOff } from '../inputs/OnOff';

type OnOffFieldProps = {
    label:string,
    text:string,
    toolTip?:React.ReactNode,
    active:boolean
    disabled?:boolean,
    onChange:(newValue:boolean) => void,
};

export function OnOffField(props:OnOffFieldProps)
{
    return (
        <FormField
            toolTip={props.toolTip}
            label={props.label} 
            inputComponent={
                <Flex gap={4}>
                    <OnOff active={props.active} disabled={props.disabled} onClick={() => props.onChange(!props.active)} />
                    {props.text}
                </Flex>
            }
        />
    )
}